import { useTheme } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { MainLinks } from 'src/feature/header/component/original/organism/MainLinks'
import { ControlPanelSidebar } from 'src/feature/control-panel/component/ControlPanelSidebar'
import { useUserStore } from 'src/feature/user/store/user.store'
import { MyTeamSidebar } from 'src/feature/my-team/component/organisms/MyTeamSidebar'
import { useAuthStore } from 'src/feature/auth/store/auth.store'
import { OrganisationRole } from 'src/feature/control-panel/model/OrganisationRole'
import { ELearningSidebar } from 'src/feature/e-learning/component/organism/ELearningSidebar'
import { ProjectBuilderSidebar } from 'src/feature/project-builder/component/organisms/ProjectBuilderSidebar'

export const Mobilelayout = observer(() => {
  const theme = useTheme()
  const userStore = useUserStore()
  const authStore = useAuthStore()

  return (
    <AppBox
      sx={{
        flexDirection: 'column',
        gap: theme.spacing(15),
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <MainLinks isOpen />
      {(userStore.sitemap?.modules ?? []).some(s => s.key === 'eLearningV2') && <ELearningSidebar isOpen />}
      {authStore.hasRole(OrganisationRole.UserAdministrator) && (userStore.sitemap?.modules ?? []).some(s => s.key === 'skillGap') && <MyTeamSidebar isOpen />}
      {authStore.hasRole(OrganisationRole.UserAdministrator) && (userStore.sitemap?.modules ?? []).some(s => s.key === 'projectBuilder') && <ProjectBuilderSidebar isOpen />}
      {(userStore.sitemap?.modules ?? []).filter(s => s.key === 'controlpanel' && s.level === 'admin').length > 0 && <ControlPanelSidebar isOpen />}
    </AppBox>
  )
})
